document.addEventListener("DOMContentLoaded", function () {
  function setSingaporeDefault() {
    const select = document.querySelector("#wRegisterForm-select-1");
    if (select) {
      select.value = "+65"; // set Singapore as default
      // in case the app triggers change events
      select.dispatchEvent(new Event("change", { bubbles: true }));
      return true;
    }
    return false;
  }

  // Try immediately
  if (!setSingaporeDefault()) {
    // If not available yet, observe until it's added
    const observer = new MutationObserver(() => {
      if (setSingaporeDefault()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});
